import kamala from '../../kamala'
import CollapseTransition from './collapse-transition'
import {
  BounceTopTransition,
  BounceLeftTransition,
  BounceBottomTransition,
  BounceRightTransition,
  BounceTransition,
} from './bounce-transition'

import TransitionAnimation from './transition-animation'

const KTransitionFamily = {
  KCollapseTransition: CollapseTransition,
  KBounceTopTransition: BounceTopTransition,
  KBounceLeftTransition: BounceLeftTransition,
  KBounceBottomTransition: BounceBottomTransition,
  KBounceRightTransition: BounceRightTransition,
  KBounceTransition: BounceTransition,

  KTransitionAnimation: TransitionAnimation,

  install: function (Vue) {
    kamala(Vue)
    Vue.component(CollapseTransition.name, CollapseTransition)
    Vue.component(BounceTopTransition.name, BounceTopTransition)
    Vue.component(BounceLeftTransition.name, BounceLeftTransition)
    Vue.component(BounceBottomTransition.name, BounceBottomTransition)
    Vue.component(BounceRightTransition.name, BounceRightTransition)
    Vue.component(BounceTransition.name, BounceTransition)
  },
}

export {
  CollapseTransition,
  BounceTopTransition,
  BounceLeftTransition,
  BounceBottomTransition,
  BounceRightTransition,
  BounceTransition,
}

export default KTransitionFamily
